var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,_vm._b({tag:"component",staticClass:"nav-item",attrs:{"tag":"li"},on:{"click":_vm.hideSidebar}},'component',_vm.$attrs,false),[_c('a',{staticClass:"nav-link",on:{"click":_vm.hideSidebar}},[_vm._t("default",function(){return [(_vm.icon)?_c('i',{class:_vm.icon}):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.name))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }